/**
 * @file paddle Wave Summit 2020 开源项目列表
 * @author FengGuang(fengguang01@baidu.com)
 */
import React, {useMemo} from 'react';

import {IOpenSourceProjectProps} from './types';
import A from '../../../../components/a/A';


const OpenSourceProjectTable: React.FC<IOpenSourceProjectProps> = (props) => {
    const [
        topList,
        list
    ] = useMemo(() => {
        const theList = props.list || [];
        const tList = theList.filter(i => i.isTop);
        const list = theList.filter(i => !i.isTop);



        return [
            tList,
            list
        ];
    }, [props.list]);


    return (
        <div className="paddle-ws2020-osp-table-wrap">
            <table className="paddle-ws2020-osp-table">
                <tbody>
                {topList.map((row, index) => (
                    <tr key={index}>
                        <td>
                            <span>{index + 1}</span>
                        </td>
                        <td>
                            <span>{row.projectName}</span>
                        </td>
                        <td>
                            <span>{row.githubId}</span>
                        </td>
                        <td>
                            <span>{row.startNum}</span>
                        </td>
                        <td className="paddle-ws2020-osp-table-btn">
                            <A
                                href={row.link}
                                target
                            >
                                为它投票
                            </A>
                        </td>
                    </tr>
                ))}
                {list.map((row, index) => (
                    <tr key={index}>
                        <td>
                            <span>{index + 1}</span>
                        </td>
                        <td>
                            <span>{row.projectName}</span>
                        </td>
                        <td>
                            <span>{row.githubId}</span>
                        </td>
                        <td>
                            <span>{row.startNum}</span>
                        </td>
                        <td className="paddle-ws2020-osp-table-btn">
                            <A
                                href={row.link}
                                target
                            >
                                为它投票
                            </A>
                        </td>
                    </tr>
                ))}
                </tbody>
            </table>
        </div>
    );
};

export default OpenSourceProjectTable;
